// removed by extract-text-webpack-plugin
module.exports = {"settings":"settings___2Qxu9","LoaderButton":"LoaderButton___36Woh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Settings.module.less
// module id = 740
// module chunks = 0